import { Visibility } from '@mui/icons-material';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import type { PresenceViewer } from './PresenceContract';

export function viewersForItem(viewers: PresenceViewer[], type: string, id: string) {
	return viewers.filter((viewer) => (viewer.itemType === type && viewer.itemId === id) || (viewer.relatedItemType === type && viewer.relatedItemId === id));
}

export function PresenceIndicator({ viewers, label = 'Viewing', showLabel = false }: { viewers: PresenceViewer[]; label?: string; showLabel?: boolean }) {
	const users = Array.from(new Map(viewers.map((viewer) => [viewer.userId, viewer])).values());
	if (!users.length) {
		return null;
	}
	const description = `${label}: ${users.map((viewer) => viewer.displayName).join(', ')}`;
	return (
		<Tooltip title={description}>
			<Box component="span" aria-label={description} sx={{ display: 'inline-flex', color: 'info.main', flexShrink: 0 }}>
				<Stack component="span" direction="row" spacing={0.5} alignItems="center">
					<Visibility sx={{ fontSize: 16 }} />
					<Typography component="span" variant="caption">{showLabel ? `${label} (${users.length})` : users.length}</Typography>
				</Stack>
			</Box>
		</Tooltip>
	);
}
